import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTosee = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#tosee_svg__a)'>
      <path
        fill='#A31B06'
        fillRule='evenodd'
        d='M0 22.001h21.546V9.016h-3.509v9.534H3.507V9.016H0v12.985M17.995 8.925V5.462L10.773 0 3.55 5.461V8.93l7.223-5.46 7.222 5.46zm.039 4.144a6 6 0 0 1-3.316-1.001A5.95 5.95 0 0 1 12.519 9.4a5.925 5.925 0 0 1 1.293-6.48 5.989 5.989 0 0 1 6.504-1.29 5.96 5.96 0 0 1 2.678 2.19A5.93 5.93 0 0 1 24 7.125a5.95 5.95 0 0 1-1.75 4.2 6 6 0 0 1-4.216 1.745'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='tosee_svg__a'>
        <path fill='#fff' d='M0 .001h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgTosee)
export default ForwardRef
